import { getUser } from '@/utils/tokenStorage'
import { SELECT_PAGOS } from './constants'
import { nextTick } from 'vue'

const getUsersObject = () => {
  return (
    getUser() || {
      hotel: '',
      iniciales: '',
      permiso: [],
      usuario: '',
      usuario_id: null
    }
  )
}

export const formatDate = (stringDate) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  return new Date(stringDate).toLocaleDateString('es-ES', options)
}

export const userCandEditTurnos = () => {
  const user = getUsersObject()
  return user.permiso.includes('admin') || user.permiso.includes('adminTurnos')
}

export const userCandReadAllTurnos = () => {
  const user = getUsersObject()
  return (
    user.permiso.includes('admin') ||
    user.permiso.includes('verAllTurnos') ||
    user.permiso.includes('adminTurnos')
  )
}

export const userCandReadTurnos = () => {
  const user = getUsersObject()
  return (
    user.permiso.includes('admin') ||
    user.permiso.includes('turnos') ||
    // user.permiso.includes('verAllTurnos') ||
    user.permiso.includes('adminTurnos')
  )
}

export const userIsAdmin = () => {
  const user = getUsersObject()
  return user.permiso.includes('admin')
}

export const userIsRecepcion = () => {
  const user = getUsersObject()
  return user.permiso.includes('admin') || user.permiso.includes('recep')
}

export const formatCurrency = (value) => {
  // Convertimos a número y redondeamos a 2 decimales
  // console.log('value', value)
  const roundedValue = Number(parseFloat(value).toFixed(2))
  // console.log('roundedValue', roundedValue)
  const result = new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(roundedValue)
  // console.log('result', result)
  return result
}

export const getEnvVariable = (key, defaultValue) => {
  // Cargar variables de entorno

  key = key.replace('VITE_', '')
  const vueKey = key.startsWith('VUE_APP_') ? key : `VUE_APP_${key}`
  if (process.env[vueKey] !== undefined) {
    return process.env[vueKey]
  }

  if (process.env[key] !== undefined) {
    return process.env[key]
  }

  // console.log(`Variable ${vueKey} not found, using default:`, defaultValue)
  return defaultValue
}

export const showTipoPagoText = (tipo) => {
  const tipoPago = SELECT_PAGOS.find((item) => item.value == tipo)
  if (tipoPago) {
    return tipoPago.text
  }
  return ''
}

export const getPagosGroupTitle = (type) => {
  switch (type.toUpperCase()) {
    case 'C':
      return 'Cancelaciones y Comisiones'
    case 'E':
      return 'Pagos en Efectivo'
    case 'H':
      return 'Pagos en Recepción'
    case 'I':
      return 'Pagos por Cheque o Transferencia'
    default:
      return 'Otros'
  }
}

export const getTodayDate = () => new Date()

export const getISOWeekNumber = (date) => {
  console.log('getISOWeekNumber(date)', date)
  const tempDate = new Date(date)
  tempDate.setHours(0, 0, 0, 0)

  // Ajustar al jueves de la semana actual
  tempDate.setDate(tempDate.getDate() + 3 - ((tempDate.getDay() + 6) % 7))

  // Calcular el primer jueves del año
  const firstThursday = new Date(tempDate.getFullYear(), 0, 4)
  firstThursday.setDate(
    firstThursday.getDate() + 3 - ((firstThursday.getDay() + 6) % 7)
  )

  // Calcular la diferencia en días y determinar el número de semanas
  const weekNumber =
    Math.round((tempDate - firstThursday) / (7 * 24 * 60 * 60 * 1000)) + 1
  console.log('WEEKNUMBER', weekNumber)
  return weekNumber
}

export const focusFirstInput = async () => {
  await nextTick()
  const firstInput = document.querySelector('.v-field__input:not([readonly])')
  if (firstInput) {
    firstInput.focus()
  }
}

/**
 * Determina si un color es oscuro basado en su luminosidad.
 * @param {string} color - Color en formato hexadecimal (#RRGGBB o #RGB)
 * @returns {boolean} - true si el color es oscuro, false si es claro
 */
export const isColorDark = (color) => {
  // Eliminar el símbolo # si existe
  color = color.replace(/^#/, '')

  // Convertir formato abreviado (#RGB) a formato completo (#RRGGBB)
  if (color.length === 3) {
    color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2]
  }

  // Convertir a valores RGB
  const r = parseInt(color.substring(0, 2), 16)
  const g = parseInt(color.substring(2, 4), 16)
  const b = parseInt(color.substring(4, 6), 16)

  // Calcular la luminosidad (fórmula estándar)
  // Luminosidad = 0.299*R + 0.587*G + 0.114*B
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Un valor de luminosidad menor a 0.5 se considera oscuro
  return luminance < 0.6
}

export const processImporte = (importe) => {
  if (importe === null || importe === undefined || importe === '') {
    console.log('importe null', importe)
    importe = 0
  } else {
    // Reemplazar comas por puntos para manejar decimales en formato español
    const formattedValue = importe.toString().replace(/,/g, '.')
    // Verificar si es un número válido usando una expresión regular
    // Acepta números enteros y decimales (con punto como separador)
    if (!/^-?\d+(\.\d+)?$/.test(formattedValue)) {
      importe = 0
    } else {
      // Convertir a número
      importe = parseFloat(formattedValue)
    }
  }
  return importe
}
